const DEFAULT_TWITTER_SITE = '@Spotahome';

const DEFAULT_PROPERTIES = {
  site: DEFAULT_TWITTER_SITE
};

const PROPERTIES_MAP = {
  card: 'twitter:card',
  site: 'twitter:site',
  title: 'twitter:title',
  description: 'twitter:description',
  imageSrc: 'twitter:image:src',
  url: 'twitter:url'
};

export function createTwitterMetas(props = {}) {
  const mergedProps = { ...DEFAULT_PROPERTIES, ...props };
  const allowedKeys = Object.keys(PROPERTIES_MAP);

  return allowedKeys
    .filter(key => typeof mergedProps[key] !== 'undefined')
    .reduce(
      (acc, key) => [
        ...acc,
        {
          name: PROPERTIES_MAP[key],
          content: mergedProps[key]
        }
      ],
      []
    );
}

export default {
  createTwitterMetas,
  DEFAULT_TWITTER_SITE
};
